export default __webpack_public_path__ + "static/media/machine-learning.7f3bcd14.jpg";